import React from 'react';
import {FormattedMessage, FormattedHTMLMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {
  SLS_update,
} from "lib/sls";
import events from 'lib/events.js';

const STATUSES = {
    INITIAL: 0,
    INPROGRESS: 1,
    COMPLETE: 2,
    FAILED: 3,
};

const MS_TO_COMPLETE = 360*1000;
const UPDATE_FREQUENCY_MS = 1000;

class FirmwareRequired extends React.Component {

    static propTypes = {
        SLSAvailableFirmware: PropTypes.string,
    };

    constructor(props){
        super(props);
        this.state = {
            status: STATUSES.INITIAL,
            progress: 0, //Goes from 0 to 1.
            timerId: undefined,
        };
    }

    handleUpdateClick = () => {

        // Setup start time and interval to update the minutes left.
        // The interval stops at 99% and the actual request below
        // will change the state to complete or failed appropriately.
        let startTime = (new Date()).getTime();
        let timerId = setInterval(() => {
            let curTime = (new Date()).getTime();
            let curProgress = (curTime - startTime)/MS_TO_COMPLETE;
            if(curProgress <= 0.99){
                this.setState({
                    progress: curProgress,
                });
            }else{
                if(this.state.timerId !== undefined){
                    clearInterval(this.state.timerId);
                    this.state.timerId = undefined;
                }
                this.setState({
                    progress: 0.99,
                });
            }
        }, UPDATE_FREQUENCY_MS);

        // Change ui to show progress bar.
        this.setState({
            status: STATUSES.INPROGRESS,
            progress: 0,
            timerId: timerId,
        });

        // Actually start the update process.
        SLS_update()
        .then((res) => {
            if(res.CanDoUpdate === undefined || res.CanDoUpdate) throw "Firmware update failed."
        })
        .then(() => {
            this.setState({
                status: STATUSES.COMPLETE,
            });
        })
        .catch((err) => {
            console.error(err);
            this.setState({
                status: STATUSES.FAILED,
            });
        })
        .finally(() => {
            if(this.state.timerId !== undefined){
                clearInterval(this.state.timerId);
                this.state.timerId = undefined;
            }
        });
    }

    handleCompleteClick = () => {
        events.publish('firmware.updateDone', window.location.hash);
    }

    handleFeedbackClick = () => {
        events.publish('bug-report');
    }

    render() {

        let BAR_AND_BUTTON;
        switch (this.state.status){
            case STATUSES.INITIAL:
                BAR_AND_BUTTON = <button className="btn btn-primary" onClick={this.handleUpdateClick}><FormattedMessage id="general.update"/></button>;
                break;
            case STATUSES.INPROGRESS:
                let percentWidthDisplay = Math.round(this.state.progress*100).toString() + "%";
                let minutesRemaining = Math.ceil((1-this.state.progress)*MS_TO_COMPLETE/60000);
                BAR_AND_BUTTON = <React.Fragment>
                        <div className="progressandtime">
                            <h3 className="progresstext">{percentWidthDisplay} <FormattedMessage id="general.complete"/></h3>
                            <span className="timeremaining">{minutesRemaining} <FormattedMessage id="general.minutes.remaining" /></span>
                        </div>
                        <div className="progressbar">
                            <div className="progressbarinner inprogress"></div>
                        </div>
                        <div className="donotturnoff"><FormattedMessage id="analysis.analysis.firmwareRequired.donotturnoff" /></div>
                    </React.Fragment>;
                break;
            case STATUSES.COMPLETE:
                BAR_AND_BUTTON = <React.Fragment>
                        <div className="progressandtime">
                            <h3 className="progresstext">100% <FormattedMessage id="general.complete"/></h3>
                        </div>
                        <div className="progressbar">
                            <div className="progressbarinner complete"></div>
                        </div>
                            <button className="btn btn-primary" onClick={this.handleCompleteClick}>
                                <FormattedMessage id="general.complete"/>
                            </button>
                    </React.Fragment>;
                break;
            case STATUSES.FAILED: 
                BAR_AND_BUTTON = <React.Fragment>
                        <div className="progressandtime">
                            <h3 className="progresstext failed"><FormattedMessage id="general.update.failed" /></h3>
                        </div>
                        <div className="progressbar">
                            <div className="progressbarinner failed"></div>
                        </div>
                        <div className="bioguardline">
                            <b><FormattedMessage id="support.technical.solutions"/>:</b> 1-800-859-7946
                        </div>
                        <button className="btn btn-primary" onClick={this.handleFeedbackClick}>
                            <FormattedMessage id="general.submit.feedback" />
                        </button>
                    </React.Fragment>;
                break;
        }

        let versionCopy = this.props.SLSAvailableFirmware ? (" v" + this.props.SLSAvailableFirmware) : "";

        return <div className="full-width-card firmwareRequired initial_state">
            <span className="bl bl-attention fa-lg error"></span>
            <h2 className="title"><FormattedMessage id='analysis.analysis.firmwareRequired.title'/></h2>
            <div>
                <FormattedHTMLMessage id='analysis.analysis.firmwareRequired.body' values={{version: versionCopy}}/>
            </div>
            {BAR_AND_BUTTON}
        </div>
        ;
    }
}


export default injectIntl(FirmwareRequired);